export default __webpack_public_path__ + "static/media/the-bottles-thumb.1e384adb.jpg";